import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";

import { Dialog } from "primereact/dialog";
import MeaButton from "../../../../components/MeaButton";
import { Toast } from "primereact/toast";
import SessionsListComponent from "../../sessions/components/SessionsListComponent";

const DayCoursesModal = forwardRef((props, ref) => {
  const { filter, schoolId, trainingId } = props
  //
  const [active, setActive] = useState(false);
  const [callbackFn, setCallbackFn] = useState(() => { });
  const [elementQuery, setElementQuery] = useState();
  //
  const [loading, setLoading] = useState(false);
  //
  const toast = useRef(null);
  //

  //
  useImperativeHandle(ref, () => ({
    show: (callback, elementQuery) => {
      setCallbackFn(() => callback);
      setElementQuery(elementQuery);
      setActive(true);
    },
    getElementQuery: () => elementQuery,
  }));
  //

  const footerContent = (
    <div>
      <MeaButton
        label="Fermer"
        icon="pi pi-times"
        disabled={loading}
        onClick={() => setActive(false)}
        className="p-button-text"
      />

    </div>
  );

  return (
    <>
      <Toast ref={toast} position="bottom-center" />
      <Dialog
        header={"Liste des séances de cours - " + filter.day}
        visible={active}
        style={{ width: "50vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        onHide={() => setActive(false)}
        footer={footerContent}
      >
        <div className="w-full">
          <SessionsListComponent
            ref={ref}
            schoolId={schoolId}
            trainingId={trainingId}
            showAddButton={false}
            showFilterButton={true}
            filter={{
              day: filter?.day,
            }}
          />
        </div>
      </Dialog>
    </>
  );
});

export default DayCoursesModal;
